export enum StorageProvider {
  s3 = 's3',
}

export enum AssetOwnerModel {
  interviews = 'interviews',
}

export enum EmailSource {
  admin = 'admin',
  self = 'self',
}

export enum PositionInterviewingMode {
  offline = 'offline',
  online = 'online',
}

export enum PositionState {
  active = 'active',
  inactive = 'inactive',
}

export enum PositionDesignation {
  senior_barista = 'senior_barista',
  barista = 'barista',
  trainee_barista = 'trainee_barista',
  apprentice = 'apprentice',
  shift_manager = 'shift_manager',
}

export enum PositionExperienceLevel {
  fresher = 'fresher',
  experienced = 'experienced',
  experience_cafe_relevant = 'experience_cafe_relevant',
}

export enum UserRole {
  blueTokaiAdmin = 'blueTokaiAdmin',
  positionAdmin = 'positionAdmin',
  candidate = 'candidate',
}

export enum InterviewState {
  invited = 'invited',
  started = 'started',
  ended = 'ended',
  cancelled = 'cancelled',
}

export enum InterviewAssets {
  candidateCameraRaw = 'candidateCameraRaw',
  candidateScreenRaw = 'candidateScreenRaw',
  candidateMicAudioRaw = 'candidateMicAudioRaw',
  agentMicAudioRaw = 'agentMicAudioRaw',
  transcriptRaw = 'transcriptRaw',
  processedTranscript = 'processedTranscript',
}

// these are all the asset types and is different from InterviewAssets because in InterviewAssets, we don't store any other assets that don't belong to an interview.
export enum AssetType {
  candidateCameraRaw = 'candidateCameraRaw',
  candidateScreenRaw = 'candidateScreenRaw',
  candidateMicAudioRaw = 'candidateMicAudioRaw',
  agentMicAudioRaw = 'agentMicAudioRaw',
  transcriptRaw = 'transcriptRaw',
  processedTranscript = 'processedTranscript',
}

export enum InterviewReportProcessingState {
  ineligible = 'ineligible', // this is when the interview is not eligible for report processing.
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  retrying = 'retrying',
  cancelled = 'cancelled', // this is when report processing fails post retrying or when we don't want to process the report anymore.
}

export enum ManageCandidatesAction {
  invite = 'invite',
  revoke = 'revoke',
  reinvite = 'reinvite',
}

export enum EmailType {
  candidateOTP = 'candidateOTP',
  candidateInvite = 'candidateInvite',
}

export enum EmailDeliveryStatus {
  sent = 'sent',
  delivered = 'delivered',
}

export enum EmailDeliveryProvider {
  resend = 'resend',
}

export enum LogType {
  windowSwitched = 'windowSwitched',
}
